export enum IntegrationEnum {
	PaquetExpress = 3,
	PdfDecoder = 13,
	XnuupStandardApis = 15,
	Geoapify = 18,
	partsMapping = 19,
	SaveEvaluationPublic = 21,
	AcesPIESUpdateProcess = 22,
	GoogleReCaptcha = 23,
	Stripe = 24,
	Flekk = 25,
	XnuupInternalServices = 26,
	ProOrder = 27,
	Qualitas = 28,
	Choque = 29,
	XnuupClaimsStandardApis = 30,
}
